export const jwtDecode = (token: string) => {
    const parts = token.split('.');

    if (parts.length !== 3) {
        throw new Error('Неверный формат токена');
    }

    const payload = parts[1];
    const decodedPayload = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    
    return decodedPayload;
}